import {
  DownloadOutlined,
  EyeOutlined,
  FilePdfOutlined
} from "@ant-design/icons"
import { Button, Flex, Space, Tag, Typography } from "antd"
import React from "react"

import { type LeadDocumentAttachment } from "../../../types/lead.documents.types.ts"

const { Text } = Typography

interface LeadViewProposalAttachmentsProps {
  attachments: LeadDocumentAttachment[]
  onViewPDF: (attachment: LeadDocumentAttachment) => void
}

export function LeadViewProposalAttachments({
  attachments,
  onViewPDF
}: LeadViewProposalAttachmentsProps) {
  return (
    <Flex vertical gap={"small"}>
      {attachments.map((attachment) => (
        <Flex
          key={attachment.id}
          align="center"
          justify="space-between"
          className="p-2 rounded-card border border-border hover:bg-gray-50 transition-colors"
        >
          <Flex align="center" flex={1} gap="large">
            <Flex align="center" gap="middle">
              <div>
                <Flex gap="small" align="center" className="mb-1">
                  <Space>
                    <FilePdfOutlined />
                    <Text strong className="text-sm">
                      {attachment?.file_name}
                    </Text>
                  </Space>
                  {attachment?.is_submitted && (
                    <Tag color={"success"}>Submitted</Tag>
                  )}
                  {attachment?.full_version && (
                    <Tag color={"blue"}>{attachment?.full_version}</Tag>
                  )}
                </Flex>
                <Text type="secondary" className="text-xs">
                  Uploaded {attachment?.created}, by{" "}
                  {attachment?.uploaded_by_name}
                </Text>
              </div>
            </Flex>
          </Flex>

          <Space>
            <Button
              onClick={() => onViewPDF(attachment)}
              variant={"outlined"}
              color={"primary"}
              icon={<EyeOutlined />}
            >
              View File
            </Button>

            <Button
              download
              href={attachment?.file_url}
              icon={<DownloadOutlined />}
              target={"_blank"}
              rel="noreferrer"
            >
              Download
            </Button>
          </Space>
        </Flex>
      ))}
    </Flex>
  )
}
